/* eslint-disable jsx-a11y/label-has-associated-control */
import { useSelector } from 'react-redux';
import { Form } from 'semantic-ui-react';
import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DatePickerLayout from '../../../../components/elements/DatePicker';

const PressReleaseModal = ({
  t,
  recordID,
  title,
  setTitle,
  titleEn,
  contentAr,
  contentEn,
  setContentAr,
  setContentEn,
  publicationDate,
  setTitleEn,
  setPublicationDate,
  newsPlace,
  keywords,
  setKeywords,
  showPreview,
  values,
  doc,
  onUpdate,
  onChange,
  fileInputRef,
  setGridModalupdate,
  gridModalupdate,
}) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const todayDate = new Date();

  return (
    <>
      {gridModalupdate && (
        <MDBModal tabIndex="-1" show={gridModalupdate} setShow={setGridModalupdate}>
          <MDBModalDialog className="flex justify-center items-center">
            <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
              <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                <MDBModalHeader>
                  <MDBModalTitle className="text-customgreen font-semibold">{t('Update Press Release')}</MDBModalTitle>
                  {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                </MDBModalHeader>
                <MDBModalBody>
                  <div className="container-fluid bd-example-row">
                    <div className="row" style={{ marginBottom: '5px' }}>
                      <div className="col-md-6 col-example">
                        <Form.Field>
                          <label className="mx-auto text-customgreen">{t('cms_title')} : </label>
                          <input
                            type="text"
                            name="title"
                            value={title}
                            maxLength={1000}
                            className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder={t('Title')}
                          />
                        </Form.Field>
                      </div>
                      <div className="col-md-6 col-example">
                        <Form.Field>
                          <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                          <input
                            type="text"
                            name="title"
                            value={titleEn}
                            maxLength={1000}
                            className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            onChange={(e) => setTitleEn(e.target.value)}
                            placeholder={t('Title')}
                          />
                        </Form.Field>
                      </div>
                      <div className="col-md-6 ms-auto col-example">
                        <Form.Field>
                          <label className="mx-auto text-customgreen">{t('cms_content')} :</label>
                          <textarea
                            type="text"
                            name="content"
                            value={contentAr}
                            className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            onChange={(e) => setContentAr(e.target.value)}
                            placeholder={t('Content')}
                          />
                        </Form.Field>
                      </div>

                      <div className="col-md-6 ms-auto col-example">
                        <Form.Field>
                          <label className="mx-auto text-customgreen">{t('Content En')} :</label>
                          <textarea
                            type="text"
                            name="content"
                            value={contentEn}
                            className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            onChange={(e) => setContentEn(e.target.value)}
                            placeholder={t('Content')}
                          />
                        </Form.Field>
                      </div>

                      <div className="col-md-6 ms-auto col-example">
                        <Form.Field>
                          <label className="mx-auto text-customgreen">{t('News Place')} : </label>
                          <input
                            type="text"
                            disabled
                            name="newsPlace"
                            value={isActive ? newsPlace?.ar_SA : newsPlace?.en_US}
                            className=" border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  cursor-not-allowed"
                            // onChange={(selectedCountry) => handleOnSelectCountry(selectedCountry)}
                            placeholder={t('newsPlace')}
                          />

                          {/* <select
                            name="filmLocation"
                            value={ filmlocation }
                            required
                            className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            onChange={ (selectedCountry) => handleOnSelectCountry(selectedCountry) }
                            placeholder={ t('cms_filmingLocation') }
                          >
                            <option value={ 0 }>{ `--${t('Select Country')}--` }</option>
                            { filmingLocation && filmingLocation.length > 0 ? (
                              filmingLocation?.map((item) => {
                                return (
                                  <option key={ item.countryID } value={ item?.countryName }>
                                    { isActive ? item?.ar_SA : item?.countryName }
                                  </option>
                                );
                              })
                            ) : (
                              <option>{ t('Select country') }</option>
                            ) }
                          </select> */}
                        </Form.Field>
                      </div>
                      <div className="col-md-6 ms-auto col-example">
                        <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                        <input
                          type="text"
                          name="keywords"
                          value={keywords}
                          onChange={(e) => setKeywords(e.target.value)}
                          className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          placeholder={t('cms_keywords')}
                        />
                      </div>
                    </div>
                    <div className="row" style={{ marginBottom: '5px' }}>
                      <div className="col-md-6 form-group flex flex-col ">
                        <DatePickerLayout
                          label={'cms_publicationDate'}
                          selectedDate={publicationDate}
                          keyValue={'to'}
                          dateTo={publicationDate}
                          setDateTo={setPublicationDate}
                          maxDate={todayDate}
                        />
                      </div>
                      <div className="col-md-6 ms-auto col-example">
                        <Form.Field>
                          <label className="mx-auto text-customgreen">{t('cms_image')} :</label>
                          <input
                            name="link"
                            type="file"
                            accept=".png, .jpg, .jpeg"
                            onChange={(showPreview, onChange)}
                            id="image-uploader"
                            ref={fileInputRef}
                            className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                            placeholder="Upload file"
                          />
                        </Form.Field>
                      </div>

                      <div className="flex justify-center mt-3  ">
                        <div className="" />
                        <img
                          style={{
                            height: '120px',
                            width: '150px',
                          }}
                          src={doc ? `data:image/jpeg;base64,${doc}` : values.imageSrc}
                          // onChange={(e) => setLink(e.target.files[0])}
                          className="card-img-top"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </MDBModalBody>
                <MDBModalFooter className="flex justify-center">
                  <button
                    className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                    onClick={() => onUpdate(recordID)}
                  >
                    {t('Submit')}
                  </button>
                  <button
                    className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                    onClick={() => setGridModalupdate(false)}
                  >
                    {t('close')}
                  </button>
                </MDBModalFooter>
              </Form>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      )}
    </>
  );
};

export default PressReleaseModal;
